// extracted by mini-css-extract-plugin
export default {"IconButton_0":"RemoveFilterButton-module__IconButton_0__zLpbL2Y"};